import {Dialog, DialogActions, DialogContent, DialogContentText, Button} from "@mui/material";
import {useNavigate} from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ExportAlertNotificationDialog = (props) => {

  const {open, handleClose, reportID} = props;

  const navigate = useNavigate();

  return (
    <Dialog
      maxWidth={'sm'} fullWidth={'sm'} 
      PaperProps={{ style: { boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: 5}}}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >

      <DialogContent sx={{textAlign: "center", bgcolor: "#40bf7e"}}><CheckCircleIcon sx={{color: "#fff", fontSize: 24}} /></DialogContent>

      <DialogContent sx={{textAlign: "center"}}> 
          <DialogContentText id="alert-dialog-description">
            The file is being generated. You can check the status here
          </DialogContentText>
      </DialogContent>

      <DialogActions sx={{justifyContent: "center", mb: 3}}>
        <Button variant="contained" sx={{background: '#3333CFCE', color: '#fff', "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}} 
          onClick={()=> navigate("/reports/report-logs-list/details?reportId=" + reportID)}
        >
          View Report
        </Button>
      </DialogActions>
    </Dialog>
  )

}

export default ExportAlertNotificationDialog